const HOME_DATA = {
	SHOW_OFF: [
		// {
		// 	id: 1,
		// 	value: 1,
		// 	key: 'Công ty chuyển phát hàng đầu Việt Nam',
		// },
		{
			id: 2,
			value: 63,
			key: 'Mạng lưới phủ sóng 63 tỉnh thành',
		},
		{
			id: 3,
			value: 15,
			key: 'Cung cấp đa dạng dịch vụ chuyển phát',
		},
		// {
		// 	id: 4,
		// 	value: 0,
		// 	key: 'Giao hàng nhanh chóng Tỷ lệ hoàn thấp',
		// },
		{
			id: 5,
			value: 1000,
			key: 'Đội ngũ chăm sóc khách hàng 24/7',
		},
	],
	TAM_NHIN_DOANH_NGHIEP: (
		<div className="company__vision">
			Đối với Nhân viên & Nhà đầu tư
			<div className="lineleft"></div>
			Xây dựng nên một tổ chức với mô hình kinh doanh vượt trội, từ đó làm phong phú đời sống vật chất và tinh thần của mỗi người.
			<br/>
			Đối với Khách hàng & Xã hội/Cộng đồng
			<div className="lineleft"></div>
			Kết nối để tạo ra một mạng lưới kinh doanh rộng khắp, thúc đẩy và giữ mạch các mối quan hệ đồng thời giúp tối ưu hóa nguồn lực cho khách hàng.
		</div>
	),
	GIA_TRI_COT_LOI: (
		<div className="company__vision core__value">
			<div className="lineright"></div>
			Sáng tạo & Đổi mới: Sáng tạo & đổi mới để luôn dẫn đầu. 
			<div className="lineright"></div>
			Tinh Thần Chiến Binh: Tinh thần chiến binh 247, sẵn sàng đối diện mọi thách thức.
			<div className="lineright"></div>
			Tôn trọng & Yêu Thương: Tôn trọng & yêu thương, đề cao vai trò con người.
			<div className="lineright"></div>
			Tinh Thần Học Hỏi: Học hỏi mọi lúc mọi nơi.
			<div className="lineright"></div>
			Kết Nối & Chia Sẻ: Kết nối vì mọi người. Chia sẻ cùng tất cả.
		</div>
	),
	ABOUT_US_CEO: {
		key: 'Ông Hoàng Quốc Anh',
		value: 'Tổng Giám Đốc Công ty Cổ phần Hai Bốn Bảy (247Express)',
		descript:
			'Chúng tôi xây dựng một doanh nghiệp phát triển bền vững và trách nhiệm qua việc' +
			' đề cao sức Sáng tạo & Đổi mới, thúc đẩy Văn hóa Chiến binh, xây dựng Văn hóa Yêu thương,' +
			' nuôi dưỡng Tinh thần Học hỏi và khuyến khích sự Kết nối - Chia sẻ trong nội bộ cũng như hướng đến môi trường bên ngoài.',
	},
}

export default HOME_DATA
